import React from 'react';
import { 
  Box, 
  Typography, 
  Card, 
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Divider,
  Link
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  ChevronRight,
  Info,
  CleaningServices,
  Build
} from '@mui/icons-material';

const NavigationItem = ({ title, description, icon, path }) => {
  const navigate = useNavigate();
  
  return (
    <ListItemButton 
      onClick={() => navigate(path)}
      sx={{ 
        py: 2,
        px: 2,
        '&:hover': {
          backgroundColor: 'rgba(53, 152, 183, 0.08)',
        }
      }}
    >
      <ListItemIcon sx={{ color: '#3598b7', minWidth: 40 }}>
        {icon}
      </ListItemIcon>
      <ListItemText 
        primary={title}
        secondary={description}
        primaryTypographyProps={{
          sx: { color: '#2e2e2e', fontWeight: 500 }
        }}
        secondaryTypographyProps={{
          sx: { color: 'rgba(46, 46, 46, 0.7)' }
        }}
      />
      <ChevronRight sx={{ color: '#3598b7' }} />
    </ListItemButton>
  );
};

const ResourceLink = ({ icon, primary, secondary, href, external }) => (
  <ListItemButton 
    component={Link}
    href={href}
    target={external ? "_blank" : "_self"}
    rel={external ? "noopener noreferrer" : ""}
    sx={{ 
      py: 1.5,
      px: 2,
      color: '#2e2e2e',
      textDecoration: 'none',
      '&:hover': {
        backgroundColor: 'rgba(53, 152, 183, 0.08)',
      }
    }}
  >
    <ListItemIcon sx={{ color: '#3598b7', minWidth: 40 }}>
      {icon}
    </ListItemIcon>
    <ListItemText 
      primary={primary}
      secondary={secondary}
      primaryTypographyProps={{
        sx: { color: 'inherit', fontWeight: 500 }
      }}
      secondaryTypographyProps={{
        sx: { color: 'rgba(46, 46, 46, 0.7)' }
      }}
    />
    {external && <ChevronRight sx={{ color: '#3598b7' }} />}
  </ListItemButton>
);

const Brent = () => {
  const navigationItems = [
    {
      title: "Brent Customer Portal",
      description: "View equipment for Rentman projects",
      icon: <Build />,
      path: "/brent/project-equipment"
    }
  ];

  const resourceItems = [
    {
      icon: <CleaningServices />,
      primary: "Equipment Cleaning Form - Jotform",
      secondary: "External",
      href: "https://form.jotform.com/253312234266349",
      external: true
    },
    {
      icon: <Build />,
      primary: "Rentman Portal",
      secondary: "External",
      href: "https://brent.rentmanapp.com/",
      external: true
    }
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h4" sx={{ mb: 3, color: '#3598b7', fontWeight: 600 }}>
        Brent Ressurser
      </Typography>

      <Card sx={{ 
        backgroundColor: '#ffffff', 
        borderRadius: 0,
        boxShadow: 'none',
        border: '1px solid rgba(0, 0, 0, 0.12)',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <Box sx={{ p: 2, borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}>
          <Typography variant="h6" sx={{ color: '#3598b7', fontWeight: 600, display: 'flex', alignItems: 'center' }}>
            <Info sx={{ mr: 1, fontSize: 20 }} />
            Navigasjon &amp; Ressurser
          </Typography>
        </Box>
        <List disablePadding sx={{ flex: 1 }}>
          {navigationItems.map((section, index) => (
            <React.Fragment key={`nav-${index}`}>
              <NavigationItem {...section} />
              <Divider />
            </React.Fragment>
          ))}

          {resourceItems.map((item, itemIndex) => (
            <React.Fragment key={`res-${itemIndex}`}>
              <ResourceLink {...item} />
              {itemIndex < resourceItems.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>
      </Card>
    </Box>
  );
};

export default Brent;

